//! Configuration handling
// Configuration and state management
export const loadConfiguration = () => {
    try {
        const savedConfig = localStorage.getItem('finalInterviewConfiguration');

        if (savedConfig) {
            const config = JSON.parse(savedConfig);

            // Map difficulty from 1-5 scale to difficulty levels
            const difficultyMap = {
                1: 'entry',
                2: 'entry',
                3: 'intermediate',
                4: 'senior',
                5: 'expert'
            };

            // Map accent to language code (supports both friendly labels and full locale like "en-US")
            const accentToLanguageMap = {
                'american': 'en-US',
                'british': 'en-GB',
                'australian': 'en-AU',
                'indian': 'en-IN',
                'spanish': 'es-ES',
                'french': 'fr-FR',
                'german': 'de-DE',
                'italian': 'it-IT',
                'portuguese': 'pt-BR',
                'japanese': 'ja-JP',
                'chinese': 'zh-CN',
                'arabic': 'ar-SA',
            };

            // Determine voice gender (prefer explicit persona.gender when present)
            const personaToGenderMap = {
                challenging: 'male',
                supportive: 'female',
                analytical: 'male',
                friendly: 'female',
                technical: 'male',
            };

            const accentRaw = config?.personality?.accent;
            const normalizedAccent = typeof accentRaw === 'string' ? accentRaw.trim() : '';
            const language =
                (normalizedAccent && /[a-z]{2}-[A-Z]{2}/.test(normalizedAccent) && normalizedAccent) ||
                accentToLanguageMap[normalizedAccent.toLowerCase()] ||
                'en-US';

            const personaGender = config?.personality?.selectedPersona?.gender;
            const voiceGender =
                (personaGender === 'male' || personaGender === 'female')
                    ? personaGender
                    : personaToGenderMap[config?.personality?.selectedPersona?.id] || 'female';

            return {
                sessionConfig: config,
                jobRole: config?.selectedRole || '',
                difficulty: difficultyMap[config?.personality?.difficulty] || 'intermediate',
                language,
                voiceGender
            };
        }
    } catch (error) {
        console.error('Failed to load configuration:', error);
    }

    return {
        sessionConfig: null,
        jobRole: '',
        difficulty: 'intermediate',
        language: 'en-US',
        voiceGender: 'female'
    };
};